import { Weapon } from '../Weapon.js';
import { WEAPONS } from '../../../../config/constants.js';

/**
 * Spirit Lance — single-target piercing bolt aimed at the boss. At level 3+
 * it can land a second hit if it's still overlapping the boss (a wide,
 * fast bolt clipping a slow-moving target) thanks to a short hit-cooldown
 * instead of the usual one-shot deactivation. At level 6 it splits into a
 * three-bolt spread. At level 8 (capstone), every bolt's pierce jumps from
 * 2 hits to 4 — a qualitative "this clips through everything" spike, not
 * just another damage-number bump.
 */
export class SpiritLance extends Weapon {
  constructor() {
    super(WEAPONS.spiritLance);
  }

  fire(origin, target, pool) {
    const dx = target.x - origin.x;
    const dy = target.y - origin.y;
    const dist = Math.hypot(dx, dy);
    if (dist === 0) return;

    const nx = dx / dist;
    const ny = dy / dist;
    const dmg = this.config.damage + this.level * 2;
    const hits = this.level >= 8 ? 4 : (this.level >= 3 ? 2 : 1);

    pool.fire({
      x: origin.x,
      y: origin.y,
      vx: nx * this.config.projectileSpeed,
      vy: ny * this.config.projectileSpeed,
      radius: this.config.projectileRadius + Math.floor(this.level / 3),
      damage: dmg,
      hits,
      hitCooldownDuration: 0.05,
      lifetime: this.config.lifetime,
      color: this.config.color,
    });

    if (this.level >= 6) {
      const spread = 0.3;
      pool.fire({
        x: origin.x,
        y: origin.y,
        vx: Math.cos(Math.atan2(ny, nx) + spread) * this.config.projectileSpeed,
        vy: Math.sin(Math.atan2(ny, nx) + spread) * this.config.projectileSpeed,
        radius: this.config.projectileRadius + 2,
        damage: dmg * 0.7,
        hits,
        hitCooldownDuration: 0.05,
        lifetime: this.config.lifetime,
        color: '#a0b8ff',
      });
      pool.fire({
        x: origin.x,
        y: origin.y,
        vx: Math.cos(Math.atan2(ny, nx) - spread) * this.config.projectileSpeed,
        vy: Math.sin(Math.atan2(ny, nx) - spread) * this.config.projectileSpeed,
        radius: this.config.projectileRadius + 2,
        damage: dmg * 0.7,
        hits,
        hitCooldownDuration: 0.05,
        lifetime: this.config.lifetime,
        color: '#a0b8ff',
      });
    }
  }
}
